import React, { useEffect, useRef, useState } from "react";
import status from "../../../asset/images/Statustick.svg";
import uploadIcon from "../../../asset/images/upload-file.svg";
import closeIcon from "../../../asset/images/close-gray.svg";
import grayuparrow from "../../../asset/images/gray-uparrow.svg";
import editIcon from "../../../asset/images/gray-pencil.svg";
import fileIcon from "../../../asset/images/file-withbg.svg";
import deleteIcon from "../../../asset/images/delete-red.svg";
import attachIcon from "../../../asset/images/attachment-offmarket.svg";
import { Off_Market } from "../../../Configuration/API_URL";
import infoIcon from "../../../../src/asset/images/yellow-info.svg";
import { AESEncryption, ApiResDecrypt, formatDate, handleSymbolPaste, noDataFound, scripInput, sortTableData, toTitleCase, validateISIN } from "../../../CommonMethhods/CommonMethods";
import { toast } from "react-toastify";
import Loader from "../../../Components/Common/Loader";
import { Modal } from "react-bootstrap";
import uparrowSort from "../../../asset/images/up-arrow-acc.svg";
import downarrowSort from "../../../asset/images/down-arrow-acc.svg";
import CustomTradeDate from "../../../CommonMethhods/CustomDate";
import SmallLoader from "../../../Components/Common/smallLoader";
import axios from "axios";


function PreviewDocuments({ onNext, onBack, setUploadedData }) {
  const storeToken = localStorage.getItem("ssoToken");
  const [openIndex, setOpenIndex] = useState(null);
  const [openIsin, setOpenIsin] = useState({});
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [data, setData] = useState(null);
  const fileInputRef = useRef(null);
  const [loader, setLoader] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [editRows, setEditRows] = useState({});
  const [deletedRows, setDeletedRows] = useState({});
  const [editingRowId, setEditingRowId] = useState(null);
  const [fieldErrors, setFieldErrors] = useState("");
  const dateLengthRefs = useRef({});
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [removedDocs, setRemovedDocs] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteRowData, setDeleteRowData] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    field: "",
    direction: "asc",
  });

  const handleSort = (field, type) => {
    setSortConfig((prev) => ({
      field,
      type,
      direction:
        prev.field === field && prev.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };


  const toggleAccordion = (index) => {
    setOpenIndex((prev) => (prev === index ? null : index));
  };

  useEffect(() => {
    if (data?.clients?.length > 0) {
      setOpenIndex(0);
    }
  }, [data]);

  const getGroupedData = (rows) => {
    return rows.reduce((acc, row) => {
      if (!acc[row.isin]) acc[row.isin] = [];
      acc[row.isin].push(row);
      return acc;
    }, {});
  };

  const handleUploadClick = (index) => {
    document.getElementById(`file-${index}`).click();
  };

  const handleFileChange = async (e, index) => {
    const file = e.target.files[0];
    if (!file) return;
    const MAX_SIZE = 5 * 1024 * 1024;

    if (file.size > MAX_SIZE) {
      toast.error("File size must be less than or equal to 5MB");
      e.target.value = "";
      return;
    }

    const isValidType =
      file.name.endsWith(".pdf") ||
      file.name.endsWith(".jpg") ||
      file.name.endsWith(".png");

    if (!isValidType) {
      toast.error("Only PDF/JPG/PNG allowed");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    // 🔥 IMPORTANT → identify client
    formData.append("clientCode", data?.clients[index]?.clientCode);

    try {

      const response = await axios.post(
        Off_Market.uploadSupportFile,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${storeToken}`,
          },
        }
      );

      const res = response?.data;

      if (res?.status === 0) {
        toast.success(res?.data);
        getTableData();
        setUploadedFiles((prev) => ({
          ...prev,
          [index]: file,
        }));

      } else {
        toast.error(res?.message);
      }

    } catch (error) {
      console.log(error, "error");

    } finally {
      e.target.value = "";
    }
  };

  const getTableData = async () => {
    setLoader(true);

    const payload = {
      pageNo: -1,
      pageSize: -1
    }
    let encPayload = AESEncryption(payload);

    try {
      const getDetails = await axios.post(
        Off_Market.getPreviewData,
        `"${encPayload}"`,

        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const res = ApiResDecrypt(getDetails?.data);

      if (res?.status === 0) {

        const transformedData = res?.data?.tradeDetails.map((client) => {
          let srNo = 1;

          return {
            clientName: client?.clientName,
            clientCode: client?.clientCode,
            supportingDoc: client?.supportingDoc,
            totalRecords: client?.totalRecords,
            isinCount: client?.isinCount,
            serviceRequestId: client?.serviceRequestId,

            rows: client?.trades.map((trade) => ({
              id: trade?.id,
              srNo: srNo++,
              exchange: trade?.exch,
              symbol: trade?.symbol,
              isin: trade?.isin,
              qty: trade?.qty,
              price: trade?.avgPrice,
              date: trade?.tradeDate,
              schName: trade?.schName,
            })),
          };
        });
        setData({
          clients: transformedData,
          summary: {
            totalClientCount: res.data.tradeDetails.length,
            totalRecords: res.data.totalCount,
          },
        });
        setUploadedData(transformedData)

      } else {
        setData(null);
        toast.error(res?.data);
      }
    } catch (error) {
      console.log(error);

    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    getTableData();
  }, []);

  const convertToISO = (dateStr) => {
    if (!dateStr) return null;
    const separator = dateStr.includes("/")
      ? "/"
      : "-";
    const parts = dateStr.split(separator);
    if (parts.length !== 3) return null;
    const [day, month, year] = parts;
    const date = new Date(`${year}-${month}-${day}`);
    return isNaN(date.getTime())
      ? null
      : date.toISOString();
  };

  const editSubmitData = async (customPayload = null, skipDocValidation = false) => {
    console.log(editRows, "editRows");

    const missingDocs = data?.clients?.filter(
      (client, index) => !uploadedFiles[index] && !client?.supportingDoc
    );

    if (missingDocs.length > 0) {
      toast.error("Please upload supporting document for all clients.");
      return;
    }

    const finalPayload = data.clients.map((client, index) => {

      const editsObj = editRows[index] || {};

    const edits = Object.values(editsObj).map((row) => ({
        id: row.id,
        exchange: row.exchange,
        scriptName: row.schName,
        symbol: row.symbol,
        isin: row.isin,
        quantity: Number(row.qty),
        averagePrice: Number(row.price),
        tradeDate: convertToISO(row.date),
      }))
      .filter((row) => row.tradeDate);

    return {
      clientCode: client.clientCode,
      edits,
      deletes: [],
    };
  });
      if (finalPayload.length === 0) {
        toast.error("No client has uploaded a supporting document.");
        return;
      }

      setSubmitLoader(true);
    
    const encPayload = AESEncryption(finalPayload);

    try {
      const getData = await axios.post(
        Off_Market.bulkSubmitData,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }

      );
      const res = ApiResDecrypt(getData?.data);        
      if (res?.status === 0) {
        toast.success(res?.data?.message)
        setEditingRowId(null);
        await getTableData();
        if(!skipDocValidation){
          onNext();
        }

      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);

    } finally {
      setSubmitLoader(false);
    }
  };

   const deleteTradeRow = async (payload, skipDocValidation = false) => {
    
    if (!skipDocValidation) {
      const missingDocs = data?.clients?.filter(
        (client, index) =>
          !uploadedFiles[index] && !client?.supportingDoc
      );

      if (missingDocs?.length > 0) {
        toast.error("Please upload supporting document");
        return;
      }
    }
    setDeleteLoader(true);
    const encPayload = AESEncryption(payload);

    try {
      const getData = await axios.delete(
        Off_Market.deleteTrade,
        {
        data: `"${encPayload}"`,
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
            
          },
        },
      );
      const res = ApiResDecrypt(getData?.data);
      if (res?.status === 0) {
        toast.success(res?.data)
        setShowDeleteModal(false);

        await getTableData();
        // if (!skipDocValidation) {
        //   onNext();
        // }

      } else {
        toast.error(res?.message);
      }
    } catch (error) {
      console.log(error);

    } finally {
      setDeleteLoader(false);
    }
  };

  const handleEditClick = (row, clientIndex) => {
  setEditingRowId(row.id);

  const formatDateForInput = (date) => {
    if (!date) return "";

    const d = new Date(date);

    if (isNaN(d)) return "";

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}-${month}-${year}`;
  };

   setEditRows((prev) => {
    if (prev?.[clientIndex]?.[row.id]) {
      return prev;
    }

    return {
      ...prev,
      [clientIndex]: {
        ...(prev[clientIndex] || {}),
        [row.id]: {
          ...row,
          date: formatDateForInput(row.date),
        },
      },
    };
  });

  if (!dateLengthRefs.current[row.id]) {
    dateLengthRefs.current[row.id] = { current: 10 };
  } else {
    dateLengthRefs.current[row.id].current = 10;
  }
};

  const handleInputChange = (clientIndex, rowId, field, value) => {
    let updatedValue = value;

    if (field === "exchange") {
      const rawValue = value.toUpperCase().replace(/[^A-Z]/g, "");
      const prevValue = editRows?.[clientIndex]?.[rowId]?.exchange || "";
      const isDeleting = rawValue.length < prevValue.length;

      const typingRegex = /^N?$|^NS?$|^NSE$|^B?$|^BS?$|^BSE$/;

      if (!isDeleting && rawValue && !typingRegex.test(rawValue)) {
        return;
      }

      updatedValue = rawValue.slice(0, 3);
    }

    if (field === "qty") {
      updatedValue = value.replace(/\D/g, "");
    }

    if (field === "price") {
      updatedValue = value
        .replace(/[^0-9.]/g, "")
        .replace(/(\..*?)\..*/g, "$1");

      if (updatedValue.includes(".")) {
        const [int, dec] = updatedValue.split(".");
        updatedValue = int + "." + dec.slice(0, 2);
      }
    }

    if (field === "isin") {
      updatedValue = value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 12);
      const typingRegex = /^I?$|^IN$|^INE[A-Z0-9]{0,9}$/;

      if (updatedValue && !typingRegex.test(updatedValue)) {
        return;
      }

      const error = validateISIN(updatedValue);

      setFieldErrors((prev) => ({
        ...prev,
        [clientIndex]: {
          ...prev[clientIndex],
          [rowId]: {
            ...prev[clientIndex]?.[rowId],
            isin: error,
          },
        },
      }));

    }

    if (field === "date") {
      updatedValue = value;
    }

    setEditRows((prev) => ({
      ...prev,
      [clientIndex]: {
        ...prev[clientIndex],
        [rowId]: {
          ...prev[clientIndex]?.[rowId],
          [field]: updatedValue,
        },
      },
    }));
  };

  const handleDelete = (clientIndex, rowId) => {
  setDeleteRowData({
    clientIndex,
    rowId,
    clientCode: data?.clients?.[clientIndex]?.clientCode,
  });

  setShowDeleteModal(true);
};

  const confirmDelete = async () => {
    if (!deleteRowData) return;

    const { clientIndex, rowId } = deleteRowData;
    const payload = {
    id: rowId,
    clientCode: data?.clients?.[clientIndex]?.clientCode,
  };
    await deleteTradeRow(payload, true);
    setDeleteRowData(null);
  };

  const handleSymbolPaste = (e, clientIndex, rowId) => {
    e.preventDefault();

    let pasteData = e.clipboardData.getData("text");

    pasteData = pasteData.replace(/[^a-zA-Z0-9\-()\s]/g, "");

    const input = e.target;
    const currentValue = input.value;
    const cursorStart = input.selectionStart;
    const cursorEnd = input.selectionEnd;

    let newValue =
      currentValue.slice(0, cursorStart) +
      pasteData +
      currentValue.slice(cursorEnd);

    newValue = newValue.replace(/^\s+/, "");
    newValue = newValue.replace(/\s{2,}/g, " ");

    handleInputChange(clientIndex, rowId, "symbol", newValue);
  };

  const clientsWithoutDocs = data?.clients?.filter(
    (client) => !client.supportingDoc
  ) || [];

  const missingDocCount = clientsWithoutDocs.length;

  const namesArray = clientsWithoutDocs.map(c => toTitleCase(c.clientName));

  const displayNames =
    namesArray.length > 3
      ? namesArray.slice(0, 3).join(", ") + "..."
      : namesArray.join(", ");

const renderSortIcons = (field) => (
  <span className="sort-icons">
    <img
      src={uparrowSort}
      alt="upsort"
      className={
        sortConfig.field === field &&
        sortConfig.direction === "asc"
          ? "sort-arrow active"
          : "sort-arrow"
      }
    />
    <img
      src={downarrowSort}
      alt="downsort"
      className={
        sortConfig.field === field &&
        sortConfig.direction === "desc"
          ? "sort-arrow active"
          : "sort-arrow"
      }
    />
  </span>
);


  return (
    <>
      <div className="wrap-preview-section">
        {loader ?
          <div className="loader-alignment">
            <Loader />
          </div>
          :
          data && data?.clients?.length > 0 ?
            <>
              {data && (
                <div className="success-banner">
                  <img src={status} alt="status icon" />
                  <span className="bold-text">File uploaded successfully</span> •
                  {" "}{data?.summary?.totalRecords || 0} records across {data?.summary?.totalClientCount || 0} clients parsed. Review the data below and attach supporting documents for each client.
                </div>
              )}

              {data?.clients?.map((client, index) => {
                const isOpen = openIndex === index;
                const groupedByIsin = getGroupedData(client.rows || []);
                const hasSupportingDoc = (!!uploadedFiles[index] || !!client?.supportingDoc) && 
                !removedDocs[index];

                return (
                  <div className="step-content mb-extra">
                    <div className="preview-wrapper">

                      {isOpen && (
                        <div className="summary-title-wrap">
                          <span className="summary-title">Uploaded Data Summary</span>
                          <div className="wrap-upload">
                            <span className="records">{data?.summary?.totalClientCount} CLIENTS · {data?.summary?.totalIsinCount} ISINS · {data?.summary?.totalRecords} RECORDS </span>
                            <button className="back-btn" onClick={onBack}>RE-UPLOAD</button>
                          </div>
                        </div>
                      )}

                      <div className={ `client-header ${isOpen && "mb-15"}`} onClick={() => toggleAccordion(index)}>
                        <div className="client-wrapper">
                          <span className="initials"> {client?.clientName?.slice(0, 2).toUpperCase()}</span>
                          <div className="cl-wrapper">
                            <span className="cl-name">{toTitleCase(client?.clientName)}</span>
                            <div className="client-code">
                              Client code-{client?.clientCode}
                            </div>
                          </div>
                        </div>

                        <div className="accordian-upload">

                          <div className={`${hasSupportingDoc ? 
                          "wrap-upload-section disable-field" : 
                          "wrap-upload-section wrap-upload-red"}`}
                            onClick={(e) => {
                              e.stopPropagation();
                              if (hasSupportingDoc) return;
                              handleUploadClick(index);
                            }}
                          >
                            {hasSupportingDoc ?
                              <img src={uploadIcon} alt="upload icon" /> :
                              <img src={attachIcon} alt="attachment" />}

                            <button
                              className={`${hasSupportingDoc ?
                                "upload-doc-btn" :
                                "upload-doc-btn upload-doc-btn-red"}`
                              }
                              disabled={hasSupportingDoc}
                            >

                              {uploadedFiles[index]?.name ||
                                client?.supportingDoc ||
                                "Upload supporting document"}
                            </button>

                            {hasSupportingDoc && (
                              <img
                                className="close"
                                src={closeIcon}
                                alt="close"
                                style={{ cursor: "pointer" }}
                                onClick={(e) => {
                                  e.stopPropagation();

                                  setUploadedFiles((prev) => {
                                    const updated = { ...prev };
                                    delete updated[index];
                                    return updated;
                                  })
                                  setData((prev) => ({
                                      ...prev,
                                      clients: prev.clients.map((clientItem, i) =>
                                        i === index
                                          ? {
                                              ...clientItem,
                                              supportingDoc: "",
                                            }
                                          : clientItem
                                      ),
                                    }));
                                  }}
                              />
                            )}
                            <input
                              type="file"
                              id={`file-${index}`}
                              style={{ display: "none" }}
                              accept=".pdf,.jpg,.png"
                              onChange={(e) => handleFileChange(e, index)}
                            />
                          </div>

                          <img className={`${isOpen ? "open-accordian" : "arrow-accordian "}`} src={grayuparrow} alt="downarrow" />
                          </div>
                      </div>

                      {isOpen &&
                        Object.entries(groupedByIsin).map(([isin, rows]) => {
                          const defaultIsin = Object.keys(groupedByIsin)[0];
                          // const activeIsin = openIsin[index] || defaultIsin;
                          const activeIsin =
                            openIsin[index] === undefined
                              ? defaultIsin
                              : openIsin[index];
                          const isActive = activeIsin === isin;
                          const totalQty = rows.reduce(
                            (sum, r) => sum + Number(r.qty || 0),
                            0
                          );

                          const sortedRows =
                            sortConfig.field
                              ? sortTableData(
                                  rows,
                                  sortConfig.field,
                                  sortConfig.direction,
                                  sortConfig.type
                                )
                              : rows;

                          return (
                            <div key={isin} className="isin-section">
                              

                              <div
                                className={`table-footer-card ${isActive ? "open-card" : ""}`}
                                // onClick={() =>
                                //   setOpenIsin((prev) => ({
                                //     ...prev,
                                //     [index]: isin,
                                //   }))
                                // }
                                onClick={() =>
                                  setOpenIsin((prev) => ({
                                    ...prev,
                                    [index]: prev[index] === isin ? null : isin,
                                  }))
                                }
                              >
                                <div className="wrap-close-card">
                                  <div className="wrap-isin">
                                    <span className="bold-text">{rows[0]?.schName}</span>
                                    <span className="light-text">{isin}</span>
                                  </div>

                                  <div className="wrap-upload">
                                    <span className="records">{totalQty} Quantity</span>
                                    <img
                                      src={grayuparrow}
                                      alt="arrow"
                                      className={`${isActive ? "open-accordian" : "arrow-accordian"}`}
                                    />
                                  </div>
                                </div>


                                {isActive && (
                                  
                                  // <div className="client-card">
                                  <table className="data-table" onClick={(e) => e.stopPropagation()}>
                                    <thead>
                                      <tr>
                                        <th>SR No.</th>
                                        <th className="sortable-header"
                                          onClick={() => handleSort("exchange", "string")}>
                                            Exchange {renderSortIcons("exchange")}
                                        </th>
                                        {/* <th>Exchange</th> */}
                                        <th>Symbol</th>
                                        <th>ISIN</th>
                                        <th>Quantity</th>
                                        {/* <th>Avg Price ₹</th> */}
                                        <th className="sortable-header"
                                          onClick={() => handleSort("price", "number")}>
                                            Avg Price ₹ {renderSortIcons("price")}
                                            
                                          </th>
                                        {/* <th>Trade Date</th> */}
                                        <th className="sortable-header"
                                          onClick={() => handleSort("date", "date")}>
                                            Trade Date {renderSortIcons("date")}
                                          </th>
                                        <th></th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      {sortedRows.map((row, i) => {
                                        const isEditing = editingRowId === row.id;
                                        const savedRow = editRows?.[index]?.[row.id];
                                        const displayRow = savedRow || row;

                                        return (
                                          <tr key={row.id || i}>
                                            <td>{i + 1}</td>
                                            <td>{isEditing ? (
                                              <input
                                                className="edit-input"
                                                value={displayRow.exchange ?? ""}
                                                onChange={(e) =>
                                                  handleInputChange(index, row.id, "exchange", e.target.value)
                                                }
                                              />
                                            ) : (
                                              displayRow.exchange
                                            )}
                                            </td>
                                            {/* <td>{row.exchange}</td> */}
                                            <td>{isEditing ? (
                                              <input
                                              maxLength={50}
                                                className="edit-input"
                                                value={displayRow.symbol ?? ""}
                                                onChange={(e) =>
                                                  handleInputChange(index, row.id, "symbol", e.target.value)
                                                }
                                                onPaste={(e) => handleSymbolPaste(e, index, row.id)}
                                                onKeyDown={scripInput}
                                              />
                                            ) : (
                                              displayRow.symbol
                                            )}</td>
                                            <td>{isEditing ? (
                                              <input
                                                className="edit-input"
                                                value={displayRow.isin ?? ""}
                                                onChange={(e) =>
                                                  handleInputChange(index, row.id, "isin", e.target.value)
                                                }
                                              />
                                            ) : (
                                              displayRow.isin
                                            )}</td>
                                            <td>{isEditing ? (
                                              <input
                                                className="edit-input"
                                                value={displayRow.qty ?? ""}
                                                onChange={(e) =>
                                                  handleInputChange(index, row.id, "qty", e.target.value)
                                                }
                                              />
                                            ) : (
                                              displayRow.qty
                                            )}</td>
                                            <td>{isEditing ? (
                                              <input
                                                className="edit-input"
                                                value={displayRow.price ?? ""}
                                                onChange={(e) =>
                                                  handleInputChange(index, row.id, "price", e.target.value)
                                                }
                                              />
                                            ) : (
                                              displayRow.price
                                            )}</td>
                                            <td>{isEditing ? (

                                              <CustomTradeDate
                                              idPrefix={`trade-${row.id}`}
                                                value={displayRow.date ?? ""}
                                                onChange={(date) => {
                                                  setEditRows((prev) => ({
                                                    ...prev,
                                                    [index]: {
                                                      ...prev[index],
                                                      [row.id]: {
                                                        ...prev[index]?.[row.id],
                                                        date: date,
                                                      },
                                                    },
                                                  }));
                                                }}
                                              />
                                            ) : (
                                              formatDate(displayRow.date)
                                            )}</td>
                                            <td className="action-icon">
                                              <span className="edit" onClick={() => handleEditClick(row, index)}>
                                                <img src={editIcon} alt="edit" />
                                              </span>
                                              <span className="delete" onClick={() => handleDelete(index, row.id)}>
                                                <img src={deleteIcon} alt="delete" />
                                              </span>
                                            </td>
                                          </tr>
                                        )
                                      })}
                                    </tbody>
                                  </table>
                                  // </div>
                                )}
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                )
              })}

              {missingDocCount > 0 && (
                <div className="info-banner">
                  <img src={fileIcon} alt="file icon" />
                  
                  <span className="banner-text">
                    <span className="bold-text">{missingDocCount} client{missingDocCount > 1 ? "'s" : ""} </span> 
                     has no supporting document <span className="bold-name">({displayNames})</span>.
                    You can still proceed — these records will be saved as Draft in the "Doc Upload Pending" bucket and can be submitted later.</span>
                </div>
              )}

              <div className="footer-actions">
                <button className="back-btn" onClick={onBack}>BACK</button>
                <button className="submit-btns" onClick={() => editSubmitData()}>
                 {submitLoader ? <SmallLoader />
                  : <>
                  REVIEW & SUBMIT
                  </>}
                </button>
              </div>
            </>

            :
            <div className="step-content report-error-message">
              {noDataFound()}
            </div>
        }
      </div>

      <Modal
        show={showDeleteModal}
        size="lg"
        centered
        className="rm-model filter-update-telecaller iba-modal-new delete-modal"
      >
        <Modal.Body>
          <div className="close-button-modal">
            <button
              type="button"
              onClick={() => setShowDeleteModal(false)}
              className="btn-close filter-closeBtn"
              aria-label="Close"
            >
              <span className="icon-close"></span>
            </button>
          </div>
          <div className="profile-modal-content">
            <div className='iba-worning'>
              <div className="wrap-infoicon">
          <img src={infoIcon} alt="email icon" className="info-icon" />
          </div>
              <span className='conf-text'>Are you sure you want to delete this record ?</span>
            </div>

            <div className="footer-actions modal-btns">
                <button className="back-btn" onClick={() => {
                  setShowDeleteModal(false);
                  setDeleteRowData(null);
                }}>CANCEL</button>
                <button className="submit-btns" onClick={confirmDelete}>
                 {deleteLoader ?
                  <SmallLoader />
                  : <>SUBMIT</>}
                </button>
              </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default PreviewDocuments;